"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.unionListToPubSubUnion = exports.unionToPubSubUnion = exports.PubSubUnion = void 0;
const message_js_1 = require("../../solarxr-protocol/pub-sub/message.js");
const subscription_request_js_1 = require("../../solarxr-protocol/pub-sub/subscription-request.js");
const topic_handle_request_js_1 = require("../../solarxr-protocol/pub-sub/topic-handle-request.js");
const topic_mapping_js_1 = require("../../solarxr-protocol/pub-sub/topic-mapping.js");
var PubSubUnion;
(function (PubSubUnion) {
    PubSubUnion[PubSubUnion["NONE"] = 0] = "NONE";
    PubSubUnion[PubSubUnion["Message"] = 1] = "Message";
    PubSubUnion[PubSubUnion["SubscriptionRequest"] = 2] = "SubscriptionRequest";
    PubSubUnion[PubSubUnion["TopicHandleRequest"] = 3] = "TopicHandleRequest";
    PubSubUnion[PubSubUnion["TopicMapping"] = 4] = "TopicMapping";
})(PubSubUnion = exports.PubSubUnion || (exports.PubSubUnion = {}));
function unionToPubSubUnion(type, accessor) {
    switch (PubSubUnion[type]) {
        case 'NONE': return null;
        case 'Message': return accessor(new message_js_1.Message());
        case 'SubscriptionRequest': return accessor(new subscription_request_js_1.SubscriptionRequest());
        case 'TopicHandleRequest': return accessor(new topic_handle_request_js_1.TopicHandleRequest());
        case 'TopicMapping': return accessor(new topic_mapping_js_1.TopicMapping());
        default: return null;
    }
}
exports.unionToPubSubUnion = unionToPubSubUnion;
function unionListToPubSubUnion(type, accessor, index) {
    switch (PubSubUnion[type]) {
        case 'NONE': return null;
        case 'Message': return accessor(index, new message_js_1.Message());
        case 'SubscriptionRequest': return accessor(index, new subscription_request_js_1.SubscriptionRequest());
        case 'TopicHandleRequest': return accessor(index, new topic_handle_request_js_1.TopicHandleRequest());
        case 'TopicMapping': return accessor(index, new topic_mapping_js_1.TopicMapping());
        default: return null;
    }
}
exports.unionListToPubSubUnion = unionListToPubSubUnion;
